import { get } from "lodash";
import ProfileFields from "../components/registration/ProfileFields";
import { REGISTRATION_ERRORS_SET } from "../store/types";
import { mapState } from "vuex";
import CallToAction from "../components/registration/CallToAction";
import ErrorNotification from "../components/registration/ErrorNotification";
import HasTranslatedText from "./HasTranslatedText";

export default {
  data() {
    return {
      processing: false,
    };
  },

  mixins: [HasTranslatedText],

  computed: {
    ...mapState({
      profile: state => state.registration.profile,
    }),
  },

  methods: {
    async save() {
      const payload = JSON.parse(JSON.stringify(this.profile));

      this.processing = true;
      this.$store.commit(REGISTRATION_ERRORS_SET, { errors: [] });

      try {
        await this.persist(payload);
        this.handleSuccessfulSave();
      } catch (error) {
        if (!error.response || !error.response.status) {
          throw error;
        }

        const errors = get(error, "response.data.validation_messages", []);

        if (!errors.length) {
          errors.push({
            path: "generic",
            message: this.translations.formProfileErrorText,
          });
        }

        this.$store.commit(REGISTRATION_ERRORS_SET, { errors });
      } finally {
        this.processing = false;
      }
    },

    async persist() {
      throw new Error("No [persist()] method has been defined for this profile form");
    },

    handleSuccessfulSave() {
      throw new Error("No [handleSuccessfulSave()] method has been defined for this profile form");
    },
  },

  components: {
    ProfileFields,
    CallToAction,
    ErrorNotification,
  },
};
